mutation CreateProspectorContacts($input: ProspectorContactsAddInput!) {
    prospectorContactsAdd(input: $input) {
        accounts {
            name
        }
        contacts {
            id
            name
            origin {
                id
            }
            htmlUrlPath
        }
        leads {
            name
            id
        }
        numUpdatedContacts
    }
}
